export const AuthSourceGoogle = 'google'
export const AuthSourceApple = 'apple'
export const AuthSourceVK = 'vk'
export const AuthSourceEmail = 'email'
export const AuthSourceName = 'authSource'
export const RefreshTokenName = 'refreshToken'
export const VerifierName = 'verifier'
